import SectionAside from './SectionAside';

export default SectionAside;
